import { z } from 'zod';
import { BaseResponseSchema, dateSchema, uuidSchema } from './primitives.js';
export const MCP_SERVICE_ACCOUNT_SCOPES = ['mcp:read', 'mcp:write'];
export const McpServiceAccountScopeSchema = z.enum(MCP_SERVICE_ACCOUNT_SCOPES);
export const CreateMcpServiceAccountRequestSchema = z.object({
    name: z.string().min(1).max(120).trim(),
    scopes: z.array(McpServiceAccountScopeSchema).min(1).default(['mcp:read']),
});
export const McpServiceAccountViewSchema = z.object({
    id: uuidSchema,
    name: z.string(),
    keyPrefix: z.string(),
    scopes: z.array(McpServiceAccountScopeSchema),
    createdAt: dateSchema,
    revokedAt: dateSchema.nullable().optional(),
    lastUsedAt: dateSchema.nullable().optional(),
});
export const CreateMcpServiceAccountResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        account: McpServiceAccountViewSchema,
        /** Full API key — shown once at creation. */
        apiKey: z.string().min(1),
    }),
});
export const ListMcpServiceAccountsResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        accounts: z.array(McpServiceAccountViewSchema),
    }),
});
export const McpServiceAccountIntrospectRequestSchema = z.object({
    apiKey: z.string().min(1),
});
export const McpServiceAccountIntrospectResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        tenantId: uuidSchema,
        serviceAccountId: uuidSchema,
        scopes: z.array(McpServiceAccountScopeSchema),
    }),
});
//# sourceMappingURL=mcp-service-account.schemas.js.map